import {fetch} from "../../utils/dataAccess";

export default async function importFeed(feedId, forceUpdate = false) {
    let param = feedId;

    if (forceUpdate) {
        param = feedId + "&forceUpdate=true";
    }

    const response = await fetch("/import/products/feed?id=" + param);

    return response.json();
}
